import type { RootAnimationConfig } from '@/js/modules/animate/types';
import {
  DATA_INVIEW,
  DATA_THRESHOLD,
  DEFAULT_VIEW_THRESHOLD_PERCENT,
} from '@/js/modules/animate/types';

function parseThresholdRatio(value: string | null): number {
  const fallback = DEFAULT_VIEW_THRESHOLD_PERCENT / 100;

  if (value === null || value.trim() === '')
    return fallback;

  const parsed = Number(value);

  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 100)
    return fallback;

  return parsed / 100;
}

export function parseRootConfig(root: HTMLElement): RootAnimationConfig {
  return {
    inView: root.hasAttribute(DATA_INVIEW),
    threshold: parseThresholdRatio(root.getAttribute(DATA_THRESHOLD)),
  };
}
